export default function FAQ() {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-10 text-[#0e0d0b] text-center">
          Frequently Asked Questions — Piano Movers London
        </h2>

        <div className="space-y-8">
          {/* FAQ 1 */}
          <div className="border-b border-[#d4d4ce] pb-6">
            <h3 className="text-xl font-semibold mb-3 text-[#0e0d0b]">
              How many people does it take to move a piano in London?
            </h3>
            <p className="text-[#1a1916] leading-relaxed">
              The number of people required to move a piano in London depends on the type and size of the instrument. A standard upright piano typically requires a minimum of two experienced piano movers, though three or four may be needed for larger uprights or challenging access situations involving stairs or narrow passages. Baby grand pianos usually require a team of three to four specialists due to their weight and the need for leg removal and reassembly. Concert grand pianos, which can weigh up to 600 kilograms, typically require four to five trained professionals to ensure safe handling throughout the move.
            </p>
          </div>

          {/* FAQ 2 */}
          <div className="border-b border-[#d4d4ce] pb-6">
            <h3 className="text-xl font-semibold mb-3 text-[#0e0d0b]">
              Can piano movers in London move a piano up stairs?
            </h3>
            <p className="text-[#1a1916] leading-relaxed">
              Yes, professional piano movers in London are fully equipped and trained to move pianos up and down stairs safely. They use specialist equipment including piano boards with stair‑climbing capabilities, heavy‑duty straps, and protective padding to navigate staircases without damaging the instrument or property. For particularly challenging situations such as narrow Victorian staircases or multiple flights in apartment buildings, experienced piano movers may use additional techniques or equipment. In extreme cases where internal stairs are impossible, they can arrange external hoisting through windows using crane equipment.
            </p>
          </div>

          {/* FAQ 3 */}
          <div className="border-b border-[#d4d4ce] pb-6">
            <h3 className="text-xl font-semibold mb-3 text-[#0e0d0b]">
              How far in advance should I book piano movers in London?
            </h3>
            <p className="text-[#1a1916] leading-relaxed">
              For optimal scheduling flexibility, it is recommended to book piano movers in London at least 2 to 3 weeks in advance, particularly if you require a weekend or end‑of‑month slot when demand is highest. However, many reputable piano moving companies can accommodate shorter notice periods, sometimes even same‑week bookings, depending on their current schedule. For complex moves requiring special equipment such as crane hoisting, or for moves during peak periods like summer months, booking 4 to 6 weeks ahead ensures you secure your preferred date.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}